<template>
        <div  v-if="canEdit==true">
            <div class="modal show fade" id="editLetterData" tabindex="-1" aria-labelledby="editLetterDataTitle"
                style="display: block;background: #000000a1;" aria-hidden="true" v-if="openModal ==true" >
                <div class="modal-dialog modal-dialog-scrollable modal-lg two-factor-auth-sms">
                    <div class="modal-content" style="position:relative">
                        <div class="modal-header bg-transparent">
                            <button id="editLetterDataClose" type="button" class="btn-close" @click="openModalMethod" ref="closeModel"><span aria-hidden="true" >×</span></button>
                        </div>
                        <div class="modal-body pb-5 px-sm-5 mx-50">
                            <!-- Form -->
                        <form action="javascript:;" class="mt-2" v-on:submit.prevent="editLetter">
                            <div class="row">
                                <div class="col-md-4 col-12">
                                  <div class="form-group mb-2">
                                    <label for="blog-edit-title">Letter Name</label>
                                    <b-form-input
                                      class="form-control"
                                      v-model="letterName"
                                      placeholder="Letter Name"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="video-edit-input">Letter Type</label>
                                      <v-select
                                        class="v-custom-style"
                                        :height="28"
                                        v-model="letterType"
                                        :options="letterTypes"
                                      />
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="video-edit-input">Letter Group</label>
                                      <v-select
                                        class="v-custom-style"
                                        :height="28"
                                        v-model="letterGroup"
                                        :options="letterGroups"
                                      />
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="video-edit-input">Letter Round</label>
                                      <v-select
                                        class="v-custom-style"
                                        :height="28"
                                        v-model="letterRound"
                                        :options="letterRounds"
                                      />
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="video-edit-input">Letter Flow Round</label>
                                      <v-select
                                        class="v-custom-style"
                                        :height="28"
                                        v-model="letterFlowRound"
                                        :options="letterFlowRounds"
                                      />
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="blog-edit-title">Response Day Time</label>
                                      <b-form-input
                                        id="blog-edit-title"
                                        v-model="ResponseDayTime"
                                        placeholder="Response Day Time"
                                      />
                                    </div>
                                </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="blog-edit-title">Short Description</label>
                                      <b-form-input
                                        class="form-control"
                                        v-model="short_description"
                                        placeholder="Letter Name"
                                      />
                                    </div>
                                  </div>
                                <div class="col-md-4 col-12">
                                    <div class="form-group mb-2">
                                      <label for="video-edit-input">Video Type</label>
                                      <v-select
                                        class="v-custom-style"
                                        :height="28"
                                        v-model="videoType"
                                        :options="videoTypes"
                                      />
                                    </div>
                                </div>
                                <div class="col-12" v-if="videoType == 'YouTube'">
                                    <div class="form-group mb-2">
                                        <label>YouTube Video Id</label>
                                        <div id="blog-editor-wrapper">
                                            <input
                                            id="textarea-state"
                                            v-model="videoUrl"
                                            class="form-control"
                                            placeholder="Paste YouTube video 'QpsYRVkWt_4'"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 mb-2" v-else>
                                    <div class="border rounded p-2">
                                        <h4 class="mb-1">Featured Video</h4>
                                        <div class="media flex-column flex-md-row">
                                            <img src="/assets/images/slider/03.jpg" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image"/>

                                            <div class="media-body">
                                                <small class="text-muted">Please upload a video.</small>
                                                <p class="my-50">
                                                    <a href="javascript:void(0);" id="blog-image-text">video.mp4</a>
                                                </p>
                                                <div class="d-inline-block">
                                                    <div class="form-group mb-0">
                                                        <div class="custom-file">
                                                            <input type="file" class="custom-file-input" id="blogCustomFile" accept="video/*" @change="selectedVideo( $event )"/>
                                                            <label class="custom-file-label" for="blogCustomFile">Choose file</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex">
                                                    <div class="progress mt-1" style="width:70%;" v-if="percentCompleted > 0  && percentCompleted < 100">
                                                        <div class="progress-bar" :style="`width:${percentCompleted}%`">
                                                        </div>
                                                    </div>
                                                    <div v-if="percentCompleted > 0 && percentCompleted < 100 " style="margin:9px">
                                                        {{percentCompleted}}%
                                                    </div>
                                                    <div v-else-if="percentCompleted == 100" class="mt-2 text-primary">
                                                        <!-- todo handle draft and publish message -->
                                                        <div>
                                                            Processing video...
                                                        </div>
                                                    </div>
                                                    <div v-else-if="processCompleted == true" class="mt-2 text-primary">
                                                        Video uploaded successfully
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 mb-2">
                                    <div class="border rounded p-2">
                                        <h4 class="mb-1">Letter Thumbnail</h4>
                                        <div class="media flex-column flex-md-row">
                                            <img :src="file" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-if="file"/>
                                            <div v-else>
                                                <img :src="image_url" v-if="image_url" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt=" Featured Image">
                                                <img src="/assets/images/slider/03.jpg" id="blog-feature-image preview" class="rounded mr-2 mb-1 mb-md-0" width="170" height="110" alt="Blog Featured Image" v-else/>
                                            </div>

                                            <div class="media-body">
                                                <small class="text-muted">Required image resolution 800x400, image size 10mb.</small>
                                                <p class="my-50">
                                                    <a href="javascript:void(0);" id="blog-image-text">C:\fakepath\banner.jpg</a>
                                                </p>
                                                <div class="d-inline-block">
                                                    <div class="form-group mb-0">
                                                        <div class="custom-file">
                                                            <input type="file" class="custom-file-input" id="blogCustomFile" accept="image/*" data-toggle="modal" data-target="#larger" @change="selectedImg" enctype="multipart/form-data"/>
                                                            <label class="custom-file-label" for="blogCustomFile">Choose file</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <editor
                                        v-model="content"
                                        id="content"
                                        :api-key="settingStore.tinymce.api_key"
                                        :init="settingStore.tinymce.configuration"
                                    />
                                </div>
                                <div class="col-12 mt-50">
                                    <p
                                        v-for="error of vuelidate.$errors"
                                        :key="error.$uid"
                                        >

                                        <strong>{{ error.$property }}</strong>
                                        <small> :</small>
                                        <small>{{ error.$message }}</small>
                                    </p>
                                </div>
                                <div class="col-12 mt-50" v-if="EditisLoading">
                                    <button type="submit" class="btn btn-primary mr-1">Updating Letter...</button>
                                </div>
                                <div class="col-12 mt-50" v-else>
                                    <button type="submit" class="btn btn-primary mr-1">Update Letter</button>
                                </div>
                            </div>
                        </form>

                        </div>
                    </div>

                </div>

            </div>
        </div>
        <div class="modal fade text-left show" id="larger" tabindex="-1" aria-labelledby="myModalLabel17"
            style="padding-right: 15px;" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <cropper v-if='img' class="cropper" :src="img" :stencil-props="{
                            aspectRatio: 7 / 4
                        }" @change="change" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary waves-effect waves-float waves-light"
                            data-dismiss="modal">Accept</button>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import { BBadge, BLink, BFormInput, BFormTextarea, BRow, BCol } from "bootstrap-vue-3";
import { ref,reactive,computed,watch } from 'vue'
import axios from "axios";
import vSelect from 'vue-select'
import { Cropper } from 'vue-advanced-cropper'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import Editor from '@tinymce/tinymce-vue'
import 'vue-select/dist/vue-select.css';
import 'vue-advanced-cropper/dist/style.css';
import { useLetterStore } from '../../stores/LetterStore.js'
import { useSettingStore } from '../../stores/SettingStore.js'
export default {
    components: {
        BBadge,
        vSelect,
        Cropper,
        BRow,
        BCol,
        BLink,
        BFormInput,
        BFormTextarea,
        useVuelidate,
        required,
        'editor': Editor,
    },
    props:{
        openModal: {
            type: Boolean
        },
        canEdit: {
            type: Boolean
        },
        openModalMethod: {
            type: Function,
        },
        letterdata: {
            type: [Array, Object]
        },
        letterVideoType:{
            type: Number
        }
    },
    setup(props){
        const currentpageUrl=ref(""),
        letterName=ref(""),
        editedLetterId = ref(),
        content = ref(),
        EditisLoading=ref(false),
        ContentisLoading = ref(),
        short_description = ref(),
        img = ref(null),
        file = ref(null),
        closeEdit = ref(),
        closeModel = ref(),
        ResponseDayTime = ref(),
        toggleModal = ref(false),
        letterdatas = ref(props.letterdata),
        videoType = ref('YouTube'),
        videoTypes = ref(['YouTube','Custom Video']),

        letterFlowRound = ref('Pre-Dispute1'),
        letterFlowRounds =  ref([
            'Round 1 Letter','Round 2 Letter','Round 3 Letter','Round 4 Letter','Pre-Dispute','Consumer Law','Pre-Dispute1'
        ]),
        letterRound = ref('Pre-Dispute1'),
        letterRounds =  ref([
            'Round 1 Letter','Round 2 Letter','Round 3 Letter','Round 4 Letter','Pre-Dispute','Consumer Law','Pre-Dispute1'
        ]),
        letterGroup = ref('Mortgage Dispute'),
        letterGroups = ref([
            'Debt Collector','Late Payment','Credit Bureau','Debt Collector2','Creditor','Creditfixrr Flow','Car Repossession','Bankruptcy','Metro-2','Data Furnisher','Complaint',
            'Student Loan','Mortgage Dispute'
        ]),
        letterType = ref('Frivolous Response Letter'),
        letterTypes = ref([
            'Creditor Complaint','Creditor Letter #2b','Student Loan Dispute','Security Freeze','CRA Bankruptcy','LexisNexis Bankruptcy','Creditor Repossession','Late Payment','Late Payment (Creditor) Letter',
            'CRA Initial Dispute','CA Complaint','Consumer File Disclosure','Consumer Law','CRA Metro-2','Method of Verification','NO Response Letter','Frivolous Response Letter' ,'Collection Agency Failed to Validate Letter',
            'Factual Dispute Letter','Debt Validation','Conditional Acceptance'
        ]),
        videoUrl = ref(null),
        rules = computed(()=>{
           return{
                letterName: {
                    required
                },
                ResponseDayTime: {
                    required
                }
           }
        }),
        uploaded = ref(0),
        percentCompleted = ref(0),
        image_url = ref(null),
        chunks = reactive([]),
        processCompleted = ref(false);
        let videoFile=ref(null);

        function closeEditor(){
            if(props.openModal == true){
                this.toggleModal == false
            }else{
                this.toggleModal == true
            }
        }
        function uploadVideo() {
            let formData = new FormData();
            formData.append('is_last', chunks.length === 1);
            formData.append('file', chunks[0], `${videoFile.value.name}.part`);
            let config = {
                method:'POST',
                url:`/disputes/editLetter/video/${props.letterdata.id}`,
                data:formData,
                headers:{
                    'Content-Type': 'application/octet-stream'
                },
                onUploadProgress: (event)=> {
                    uploaded.value += event.loaded;
                },
            }
            percentCompleted.value = Math.floor((uploaded.value * 100) / videoFile.value.size);
            axios(config).then(({data}) => {
                chunks.shift();
                if(data.message == 'completed'){
                    processCompleted.value = true;
                    uploaded.value = 0;
                    percentCompleted.value = 0;
                    setTimeout(() => {
                        processCompleted.value = false;
                    }, 1000);
                }
            }).catch(error => {});
        }
        watch(chunks, async (newChunks, oldChunks) => {
            if (newChunks.length > 0) {
                // console.log(newChunks);
                uploadVideo();
            }
        });
        const vuelidate = useVuelidate(rules, { letterName,ResponseDayTime});
        return{
            editedLetterId,
            vuelidate,
            letterName,
            currentpageUrl,
            EditisLoading,
            ContentisLoading,
            img,
            file,
            content,
            closeEdit,
            videoType,
            videoTypes,
            letterType,
            letterTypes,
            letterRound,
            letterRounds,
            letterGroup,
            letterGroups,
            letterFlowRound,
            letterFlowRounds,
            image_url,
            videoUrl,
            toggleModal,
            closeEditor,
            closeModel,
            uploadVideo,
            ResponseDayTime,
            videoFile,
            percentCompleted,
            uploaded,
            processCompleted,
            chunks,
            letterdatas,
            short_description,
            letterStore:useLetterStore(),
            settingStore: useSettingStore(),
        }
    },
    watch: {
        async 'letterStore.toEditLetterData' (value) {
            this.letterName = value.name;
            this.letterRound = value.letter_round;
            this.letterType = value.letter_type;
            this.letterGroup = value.letter_group;
            this.letterFlowRound = value.dispute_flow_round;
            this.ResponseDayTime = value.response_days_time;
            this.content = value.letter_description;
            this.editedLetterId = value.id;
            this.image_url = value.letter_image;
            this.short_description = value.short_description;
            if( value.video_type == 1){
                this.videoType = 'YouTube'
                this.videoUrl = this.removeEmbedLink(value.letter_video)
            }else{
                this.videoType = 'Custom Video'
                this.videoUrl = value.letter_video;
            }
        },
    },
    created(){
        this.currentpageUrl = window.location.href;
        // console.log(this.letterdata);
    },
    mounted() {
        // this.getLetter(1);
    },

    methods: {
        selectedImg(e) {
            e.preventDefault()
            const file = e.target.files[0];
            this.img = URL.createObjectURL(file);
        },
        converter(canvas) {
            this.file = canvas.toDataURL();
        },
        change({ coordinates, canvas }) {
            this.converter(canvas)
        },
       async editLetter() {
            let $this = this;
            let letterName = this.letterName,
            editedLetterId = this.editedLetterId,
            letterRound = this.letterRound,
            letterType = this.letterType,
            letterFlowRound = this.letterFlowRound,
            ResponseDayTime  = this.ResponseDayTime,
            letterGroup = this.letterGroup,
            videoUrl = this.videoUrl;
            const isFormCorrect = await this.vuelidate.$validate()
            if(isFormCorrect) {
                this.EditisLoading = true;
                if(this.videoType == 'YouTube'){

                    let params = {
                        name:letterName,
                        letter_round:letterRound,
                        letter_type:letterType,
                        dispute_flow_round:letterFlowRound,
                        response_days_time:ResponseDayTime,
                        image:this.file,
                        letter_video:videoUrl,
                        letter_group:letterGroup,
                        video_type:1,
                        letter_description:this.content,
                        short_description: this.short_description
                    }
                    axios.post(`/disputes/editLetter/${editedLetterId}`,params).then(({data})=>{
                        this.EditisLoading=false
                        toastr.success(letterName+' Letter updated successfully','Success');
                        this.closeModel.click();
                        window.location.reload()
                    });
                }else if(this.videoType == 'Custom Video'){
                    let params = {
                        name:letterName,
                        letter_round:letterRound,
                        letter_type:letterType,
                        dispute_flow_round:letterFlowRound,
                        response_days_time:ResponseDayTime,
                        image:this.file,
                        letter_group:letterGroup,
                        letter_description:this.content,
                        video_type:0,
                        short_description: this.short_description
                    }
                    axios.post(`/disputes/editLetter/${editedLetterId}`,params).then(({data})=>{
                        this.EditisLoading=false
                        toastr.success(letterName+' Letter updated successfully','Success');
                        this.closeModel.click();
                        window.location.reload()
                    });
                }else{
                    return false;
                }
            }
        },
        selectedVideo(event) {
            this.videoFile = event.target.files[0];
            this.createChucks();
        },
        createChucks(){
            let size = 2048, chunks = Math.ceil(this.videoFile.size / size);
            for (let i = 0; i < chunks; i++) {
                this.chunks.push(this.videoFile.slice(
                    i * size, Math.min(i * size + size, this.videoFile.size), this.videoFile.type
                ));
            }
        },
        removeEmbedLink(embedLink){
            let embeded = embedLink.split("embed/");
            return embeded[1];
        }

    },

};
</script>

